export enum WeekViewActions {
  SetCurrentTip = "WeekView_SetCurrentTip",
}

export enum WeekViewCurrentTip {
  None = "None",
  Autopilot = "Autopilot",
  TeamEvent = "TeamEvent",
  EventDetails = "EventDetails",
  ColorCoding = "ColorCoding",
  AutopilotSettings = "AutopilotSettings",
}

export const setCurrentTip = (currentTip: WeekViewCurrentTip) => {
  return {
    type: WeekViewActions.SetCurrentTip,
    data: {
      currentTip,
    },
  };
};
